var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m19.3529 36.1111v-23.1111l22.6471-8v25.7778",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m19.3529 19.2222 22.6471-8",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("g", {
  className: "highlight highlight--stroke",
  stroke: "#ffd200"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.3529 39.6667c0 2.6666-2.6764 5.3333-6.1764 5.3333-3.50003 0-6.1765-2.3111-6.1765-5.3333 0-3.0223 2.67647-5.3334 6.1765-5.3334h6.1764z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41.9999 32.5556c0 2.6666-2.6765 5.3333-6.1765 5.3333s-6.1764-2.3111-6.1764-5.3333c0-3.0223 2.6764-5.3334 6.1764-5.3334h6.1765z"
})));
function SvgInstruments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruments);
export default __webpack_public_path__ + "static/media/instruments.9010218d.svg";
export { ForwardRef as ReactComponent };